import { render } from "./BusinessEmail.vue?vue&type=template&id=009b88de&scoped=true&ts=true"
import script from "./BusinessEmail.vue?vue&type=script&lang=ts"
export * from "./BusinessEmail.vue?vue&type=script&lang=ts"

import "./BusinessEmail.vue?vue&type=style&index=0&id=009b88de&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009b88de"]])

export default __exports__